import { fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule } from '@iwoca/lapi-client/introducer_portal';
import {
  MIN_DE_CREDIT,
  MIN_UK_CREDIT,
} from 'components/StandAloneCalculator/filterConfigs.helper';
import { TIntroducerApplication } from 'lendingApi/applications.types';

export const getUpdatedMinimumRepayment = async (
  isDE: boolean,
  introducerId: string,
  amount: number,
  formalOffer: TIntroducerApplication['formal_offer_sets'][number]['formal_offers'][number],
  applicationId: string,
) => {
  const isValidAmount =
    amount >= (isDE ? MIN_DE_CREDIT : MIN_UK_CREDIT) &&
    amount <= formalOffer.max_amount;

  if (!isValidAmount) {
    return null;
  }

  const { data } =
    await fetchGetApiIntroducerPortalIntroducerApplicationOfferDrawDownRepaymentSchedule(
      {
        introducerId: introducerId as string,
        applicationId,
        offerId: formalOffer.offer_id,
        query: {
          amount,
        },
      },
    );

  return data?.summary?.equal_repayment_amount;
};
